import { isTruthy } from "./_internal.js";
/** @ignore */ export function clsx(...classes) {
  function worker(mix) {
    let str = "";
    if (mix != null) {
      if (typeof mix === "number" && (isNaN(mix) || !isFinite(mix))) {
        mix = String(mix);
      }
      if (typeof mix === "string" || typeof mix === "number" || typeof mix === "bigint") {
        str += mix;
      } else if (Array.isArray(mix)) {
        for(let k = 0, y = ""; k < mix.length; y = worker(mix[k++])){
          if (y) str += (str && " ") + y;
        }
      } else if (typeof mix === "object") {
        for(const k in mix){
          const v = mix[k];
          // only include _own_ properties
          if (!Object.hasOwn(mix, k) || !isTruthy(v)) continue;
          str += (str && " ") + k;
        }
      }
    }
    return str;
  }
  return classes // rest param containing all the arguments.
  .flat(10) // max recursion depth of 10 seems reasonable.
  .filter(isTruthy) // filter out falsy + nullable values.
  .flatMap(worker) // process each argument, then flatten.
  .filter(isTruthy) // strip empty strings + extra spaces.
  .join(" "); // concatenate classes using a single space.
}
//# sourceMappingURL=mod.js.map